import { render, staticRenderFns } from "./UploadLearnTimeCard.vue?vue&type=template&id=04d01d68&scoped=true&"
import script from "./UploadLearnTimeCard.vue?vue&type=script&lang=js&"
export * from "./UploadLearnTimeCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d01d68",
  null
  
)

export default component.exports